import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import APComplianceCorporate from "./APComplianceCorporate";
import APComplianceByMill from "./APComplianceByMill";

const APCompliance = () => {
    const mainClasses = useRCAMainStyles();

    return (
        <>
            <div className={mainClasses.contentWrapper}>
                <APComplianceCorporate />
            </div>
            <div className={mainClasses.contentWrapper}>
                <APComplianceByMill />
            </div>
        </>
    );
};

export default APCompliance;
